var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "details-view",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("AirExport.CustomsClearanceTracking"),
        width: _vm.$selectByLang("650px", "810px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("Warehouse.JobNumberInformation")))
            ]),
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  "label-width": _vm.$selectByLang("70px", "100px"),
                  "label-position": "left"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessNo") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: true, no: "1" },
                      model: {
                        value: _vm.job.jobNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "jobNo", $$v)
                        },
                        expression: "job.jobNo"
                      }
                    })
                  ],
                  1
                ),
                _c("el-form-item"),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.FlightNo") } },
                  [
                    _c("el-input", {
                      attrs: {
                        disabled: true,
                        value: _vm.job.voyageFlight,
                        no: "2"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_ActualQuantity") } },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: { controls: false, no: "3" },
                      model: {
                        value: _vm.job.quantityActual,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "quantityActual", $$v)
                        },
                        expression: "job.quantityActual"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_OperationDate") } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        clearable: "",
                        no: "4"
                      },
                      model: {
                        value: _vm.job.customsDate,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "customsDate", $$v)
                        },
                        expression: "job.customsDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_ActualWeight") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "168px" },
                          attrs: { controls: false, no: "5" },
                          model: {
                            value: _vm.job.weightActual,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "weightActual", $$v)
                            },
                            expression: "job.weightActual"
                          }
                        }),
                        _c("span", { staticStyle: { "margin-left": "5px" } }, [
                          _vm._v("KGS")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_SailingDate") } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        clearable: "",
                        no: "6"
                      },
                      model: {
                        value: _vm.job.etd,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "etd", $$v)
                        },
                        expression: "job.etd"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_ActualVolume") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "168px" },
                          attrs: { controls: false, no: "7" },
                          model: {
                            value: _vm.job.cubageActual,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cubageActual", $$v)
                            },
                            expression: "job.cubageActual"
                          }
                        }),
                        _c("span", { staticStyle: { "margin-left": "5px" } }, [
                          _vm._v(" M"),
                          _c("sup", [_vm._v("3")])
                        ])
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section" },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("AirExport.CustomsClearanceInformation")))
            ]),
            _c(
              "el-form",
              [
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "8" },
                        model: {
                          value: _vm.multipleCustomsInfo,
                          callback: function($$v) {
                            _vm.multipleCustomsInfo = $$v
                          },
                          expression: "multipleCustomsInfo"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("AirExport.MultipleCustomsDeclarations")
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("cargo-ag-grid", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.multipleCustomsInfo,
                  expression: "multipleCustomsInfo"
                }
              ],
              attrs: {
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.multipleCustomsInfo,
                    expression: "multipleCustomsInfo"
                  }
                ],
                staticStyle: { margin: "5px 0" }
              },
              [
                _c("span", { staticStyle: { float: "right" } }, [
                  !_vm.isEdit
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "9" },
                              on: { click: _vm.addHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "10" },
                              on: { click: _vm.editHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "11" },
                              on: { click: _vm.delHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "12" },
                              on: { click: _vm.saveHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "13" },
                              on: { click: _vm.cancelHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
                          )
                        ],
                        1
                      )
                ])
              ]
            ),
            _c(
              "el-form",
              {
                attrs: {
                  disabled: !_vm.isEdit,
                  inline: true,
                  "label-width": _vm.$selectByLang("70px", "170px"),
                  "label-position": "left"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "14" },
                        model: {
                          value: _vm.customsInfo.commodityInspection,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.customsInfo,
                              "commodityInspection",
                              $$v
                            )
                          },
                          expression: "customsInfo.commodityInspection"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "AirExport.WhetherApplyForCommercialInspection"
                            )
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "15" },
                        model: {
                          value: _vm.customsInfo.spotInspection,
                          callback: function($$v) {
                            _vm.$set(_vm.customsInfo, "spotInspection", $$v)
                          },
                          expression: "customsInfo.spotInspection"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("AirExport.WhetherToCheck")))]
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-left": "170px" },
                    attrs: {
                      label: _vm.$t("SeaExport.StatusOfCustomsDeclaration")
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "150px" },
                        attrs: { no: "16" },
                        model: {
                          value: _vm.customsInfo.declareCustomsState,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.customsInfo,
                              "declareCustomsState",
                              $$v
                            )
                          },
                          expression: "customsInfo.declareCustomsState"
                        }
                      },
                      _vm._l(_vm.DECLARE_CUSTOMS_STATE, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.$getLangColumn(item),
                            value: item.code
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.TenBitCode") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "100px" },
                      attrs: { maxlength: 10, no: "17" },
                      on: { blur: _vm.tenDigitCodeChangeHandler },
                      model: {
                        value: _vm.customsInfo.tenDigitCode,
                        callback: function($$v) {
                          _vm.$set(_vm.customsInfo, "tenDigitCode", $$v)
                        },
                        expression: "customsInfo.tenDigitCode"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("AirExport.CustomsClearanceQuantity")
                    }
                  },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "150px" },
                      attrs: { controls: false, no: "18" },
                      on: { change: _vm.textChangeHandler },
                      model: {
                        value: _vm.customsInfo.quantityActual,
                        callback: function($$v) {
                          _vm.$set(_vm.customsInfo, "quantityActual", $$v)
                        },
                        expression: "customsInfo.quantityActual"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.OperatingCompany") } },
                  [
                    _c("el-input", {
                      attrs: { no: "19" },
                      on: { blur: _vm.queryBusinessHandler },
                      model: {
                        value: _vm.customsInfo.companyCname,
                        callback: function($$v) {
                          _vm.$set(_vm.customsInfo, "companyCname", $$v)
                        },
                        expression: "customsInfo.companyCname"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("AirExport.CustomsClearanceWeight") }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "150px" },
                          attrs: { controls: false, no: "20" },
                          on: { change: _vm.textChangeHandler },
                          model: {
                            value: _vm.customsInfo.weightActual,
                            callback: function($$v) {
                              _vm.$set(_vm.customsInfo, "weightActual", $$v)
                            },
                            expression: "customsInfo.weightActual"
                          }
                        }),
                        _c("span", { staticStyle: { "margin-left": "5px" } }, [
                          _vm._v("KGS")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("AirExport.CustomsClearanceDate") }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "120px" },
                      attrs: {
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        clearable: "",
                        no: "21"
                      },
                      model: {
                        value: _vm.customsInfo.customsDate,
                        callback: function($$v) {
                          _vm.$set(_vm.customsInfo, "customsDate", $$v)
                        },
                        expression: "customsInfo.customsDate"
                      }
                    })
                  ],
                  1
                ),
                _c("el-form-item"),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "530px" },
                      attrs: { type: "textarea", rows: 5, no: "22" },
                      model: {
                        value: _vm.customsInfo.remarks,
                        callback: function($$v) {
                          _vm.$set(_vm.customsInfo, "remarks", $$v)
                        },
                        expression: "customsInfo.remarks"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "23" },
              on: { click: _vm.okEventHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "24" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }